(() => {
  const initializeCareers = (root) => {
    if (!root || root.dataset.careersInitialized === 'true') return;

    const positionSelect = root.querySelector('[data-career-position-select]');
    const application = root.querySelector('.pc-careers__application');

    root.querySelectorAll('[data-career-position]').forEach((button) => {
      button.addEventListener('click', () => {
        const position = button.dataset.careerPosition;

        if (positionSelect && position) {
          const matchingOption = Array.from(positionSelect.options).find((option) => option.value === position);
          if (matchingOption) {
            positionSelect.value = position;
            positionSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        application?.scrollIntoView({ behavior: 'smooth', block: 'start' });

        window.setTimeout(() => {
          positionSelect?.focus({ preventScroll: true });
        }, 650);
      });
    });

    root.dataset.careersInitialized = 'true';
  };

  const initializeAllCareers = (scope = document) => {
    scope.querySelectorAll('[data-pc-careers]').forEach(initializeCareers);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllCareers(), { once: true });
  } else {
    initializeAllCareers();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllCareers(event.target));
})();
